/** @format */
import { RefObject, useEffect } from 'react';

/**
 * This hook is used to listen to blur events within the dom element its attached to
 */
export const useBlurWithin = (
    ref: RefObject<HTMLElement>,
    handler: (event: Event) => void
) => {
    const blurHandler = (event: FocusEvent) => {
        handler(event);
    };

    useEffect(() => {
        ref.current && ref.current.addEventListener('blur', blurHandler, true);

        return () => {
            ref.current &&
                ref.current.removeEventListener('blur', blurHandler, true);
        };
    }, [ref.current, handler]);
};
